/* Delegated events also support filtered collections and dynamically loaded cards. */
(()=>{
 document.addEventListener('click',event=>{
  const swatch=event.target.closest('[data-opia-swatch]');
  if(!swatch||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const card=swatch.closest('.product-item');
  if(!card)return;
  event.preventDefault();event.stopPropagation();
  card.querySelectorAll('[data-opia-swatch]').forEach(el=>el.classList.toggle('selected',el===swatch));
  card.querySelectorAll('.opia-card-color').forEach(el=>el.textContent=swatch.dataset.color);
  card.querySelectorAll('a[href*="/products/"]:not([data-opia-swatch])').forEach(el=>el.href=swatch.href);
  if(swatch.dataset.image){
   const img=card.querySelector('.product-item__image--one img, .product-item__image img');
   if(img){img.removeAttribute('srcset');img.src=swatch.dataset.image;img.alt=swatch.getAttribute('aria-label');card.classList.add('opia-variant-preview');}
  }
 },true);
})();
